import { useEffect, useState } from 'react';
export function useCyclingOrder(items, updatedAt, isReversed = false) {
    const [lastUpdate, setLastUpdate] = useState(updatedAt);
    const [orderedItems, setOrderedItems] = useState(items);
    /**
     * zero or one items can't be cycled through
     */
    if (orderedItems.length < 2) {
        return orderedItems;
    }
    useEffect(() => {
        if (updatedAt > lastUpdate) {
            if (isReversed) {
                const lastItem = orderedItems.slice(-1)[0];
                const remainingItems = orderedItems.slice(0, -1);
                setOrderedItems([lastItem, ...remainingItems]);
            }
            else {
                const firstItem = orderedItems[0];
                const remainingItems = orderedItems.slice(1, orderedItems.length);
                setOrderedItems([...remainingItems, firstItem]);
            }
            setLastUpdate(updatedAt);
        }
    }, [isReversed, lastUpdate, orderedItems, updatedAt]);
    return orderedItems;
}
//# sourceMappingURL=use-cycling-order.js.map